import { render, staticRenderFns } from "./SaladPage.vue?vue&type=template&id=62781406&scoped=true&"
import script from "./SaladPage.vue?vue&type=script&lang=js&"
export * from "./SaladPage.vue?vue&type=script&lang=js&"
import style0 from "./SaladPage.vue?vue&type=style&index=0&id=62781406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62781406",
  null
  
)

export default component.exports